module.exports = __webpack_public_path__ + "media/Components/fonts/boldLobsterTwoitalic-66907c706f6e9141cf16ebd17b7453d6.ttf";